/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%]{padding-bottom:20px}.navbar[_ngcontent-%COMP%]{margin-bottom:20px;background-color:#f0f0f0}"];
export { styles as styles };
